import React from "react";
import ProductCardProps, {ProductRow} from "./props";
import "./styles.scss";
import cpybIcon from '../../../icons/CPYB.svg';
import defaultImage from '../../../icons/placeholder-image.svg';

const ProductCardRow = ({content}: ProductRow) => {
  if (Array.isArray(content)) {
    return (
      <>
        {content.map((item, index) => (
          <span key={index}>
            {item}
          </span>
        ))}
      </>
    );
  }
  return <>{content}</>;
};

function ProductCard(props: ProductCardProps) {
  const { showButton = true, imageLoading = 'lazy' } = props;

  // Handle image error or missing image source
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.src = defaultImage;
  };

  return (
    <div className="product-card" data-e2e="product-card" data-id={props?.id}>
      <div className="product-card__header">
        <div className="product-card__header-img-wrapper">
          <img
            className="product-card__header-img"
            data-e2e="product-card-img"
            src={props.imgSrc || defaultImage}
            alt={props.imgAlt || 'Product Image'}
            onError={handleImageError}
            loading={imageLoading}
          />
        </div>
        {props.cpybLogo && (
          <div className="product-card__header-icon">
            <img src={cpybIcon} alt="Certified Professional Yacht Brokers" data-e2e="product-card-cpyb-icon"/>
          </div>
        )}
      </div>
      <div className="product-card__body">
        <h5 className="product-card__body-title" data-e2e="product-card-title">{props.title}</h5>
        <p className="product-card__body-text--row1" data-e2e="product-card-text-row1" data-details={props?.metaData1}>
          <ProductCardRow content={props.textRow1} />
        </p>
        <p className="product-card__body-text--row2" data-e2e="product-card-text-row2" data-details={props?.metaData2}>
          <ProductCardRow content={props.textRow2} />
        </p>
        <p className="product-card__body-text--row3" data-e2e="product-card-text-row3" data-details={props?.metaData3}>
          <ProductCardRow content={props.textRow3} />
        </p>
        <p className="product-card__body-text--row4" data-e2e="product-card-text-row4" data-details={props?.metaData4}>
          <ProductCardRow content={props.textRow4} />
        </p>
      </div>
      <div className="product-card__footer">
        {props.footerLogoSrc && (
          <div className="product-card__footer-logo" data-e2e="product-card-footer-logo">
            <img src={props.footerLogoSrc} alt={props.footerLogoAlt} />
          </div>
        )}
        {showButton && (
          <button className="product-card__footer-button" onClick={props.onClick} aria-label={props.buttonText} data-e2e="product-card-footer-button">
            {props.buttonText}
          </button>
        )}
      </div>
    </div>
  );
}

export default React.memo(ProductCard);
